import type { LightingConnection } from "@/shared/plan";

export const linkedLights = (
	connections: Record<string, LightingConnection>,
	switchId: string,
	key?: 1 | 2 | 3,
): string[] => [
	...new Set(
		Object.values(connections)
			.filter(
				(connection) =>
					(connection.from === switchId || connection.to === switchId) &&
					(key === undefined || (connection.key ?? 1) === key),
			)
			.map((connection) => (connection.from === switchId ? connection.to : connection.from)),
	),
];
